import React from "react";

const valueStyle = {
    color: "var(--primary-color)",
    fontWeight: "bold",
};

function isZeroLike(value) {
    if (typeof value === "string") {
        const v = value.trim();
        return (
            v === "00:00" ||
            v === "00:00:00"
        );
    }

    return false;
}

function StatRow({label, value}) {
    if (isZeroLike(value)) return null;

    return (
        <p>
            <strong>{label}:</strong> <span style={valueStyle}>{value}</span>
        </p>
    );
}

function ProjectStatBlock({project}) {
    const rows = [
        {label: "Aktuelle Woche", value: project.totalTimeCurrentWeek},
        {label: "Letzte Woche", value: project.totalTimeLastWeek},
        {label: "Aktueller Monat", value: project.totalTimeThisMonth},
        {label: "Letzter Monat", value: project.totalTimeLastMonth},
    ].filter((r) => !isZeroLike(r.value));

    if (rows.length === 0) return null;

    return (
        <li>
            <strong>{project.projectName}</strong>
            <div style={{marginTop: 6}}>
                {rows.map((r) => (
                    <StatRow key={r.label} label={r.label} value={r.value}/>
                ))}
            </div>
        </li>
    );
}

export default function StatisticsSidebar({stats}) {
    if (!stats) {
        return (
            <div>
                <h3>Loading Statistics...</h3>
            </div>
        );
    }

    const workRows = [
        {label: "Aktuelle Woche", value: stats.totalTimeCurrentWeek},
        {label: "Letzte Woche", value: stats.totalTimeLastWeek},
        {label: "Aktueller Monat", value: stats.totalTimeThisMonth},
        {label: "Letzter Monat", value: stats.totalTimeLastMonth},
    ].filter((r) => !isZeroLike(r.value));

    const projects = (stats.projectStats ?? []).filter((p) => {
        return !(
            isZeroLike(p.totalTimeCurrentWeek) &&
            isZeroLike(p.totalTimeLastWeek) &&
            isZeroLike(p.totalTimeThisMonth) &&
            isZeroLike(p.totalTimeLastMonth)
        );
    });

    return (
        <div>
            <h3>Arbeitszeiten</h3>
            {workRows.length === 0 ? (
                <p>Keine Arbeitszeiten vorhanden.</p>
            ) : (
                workRows.map((r) => <StatRow key={r.label} label={r.label} value={r.value}/>)
            )}

            <hr style={{margin: "16px 0"}}/>

            <h3>Projekte</h3>
            {projects.length === 0 ? (
                <p>Keine Projektdaten vorhanden.</p>
            ) : (
                <ul style={{paddingLeft: 18, marginTop: 8}}>
                    {projects.map((p) => (
                        <ProjectStatBlock key={p.projectId} project={p}/>
                    ))}
                </ul>
            )}
        </div>
    );
}